import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";
import { AppellateMasterData } from "types/models/appellateMaster/AppellateMasterApp";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: keyof AppellateMasterData;
  onSort: (property: keyof AppellateMasterData) => void;
}

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  const createSortHandler = (property: keyof AppellateMasterData) => () => {
    onSort(property);
  };

  const columnStyle = { width: '150px' };

  return (
    <TableHeader>
      <TableCell align="left" sx={columnStyle}>
        <TableSortLabel
          active={orderBy === "createdAt"}
          direction={orderBy === "createdAt" ? order : "asc"}
          onClick={createSortHandler("createdAt")}
        >
          Date
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" sx={columnStyle}>Customer ID</TableCell>
      <TableCell align="left" sx={columnStyle}>Ticket ID</TableCell>
      <TableCell align="left" sx={columnStyle}>Remarks</TableCell>
      <TableCell align="left" sx={columnStyle}>Source</TableCell>
      <TableCell align="left" sx={columnStyle}>Reference</TableCell>
      <TableCell align="left" sx={columnStyle}>Name</TableCell>
      <TableCell align="left" sx={columnStyle}>Mobile</TableCell>
      <TableCell align="left" sx={columnStyle}>Email</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
